module.exports = __webpack_public_path__ + "static/media/Edit.2d14617b.svg";